module.exports = __webpack_public_path__ + "img/1.dbf71a95.png";